import axios from "../config/axios";
import { authService } from "./authService";

export interface Transaction {
  id: string;
  amount?: number;
  amount_paid?: number;
  amount_due?: number;
  currency: string;
  status: string;
  description: string | null;
  created: string;
  type: string;
  subscription: string | null;
  period_start?: string;
  period_end?: string;
  metadata?: Record<string, any>;
  payment_method?: string;
  invoice?: string | null;
}

export const paymentService = {
  async getTransactions(): Promise<Transaction[]> {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error("Authentication token not found");
      }
      
      const response = await axios.get('/api/scribing/subscriptions/transactions', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      return response.data;
    } catch (error: any) {
      console.error("Error fetching transactions:", error);
      throw error;
    }
  },
  
  async downloadInvoice(invoiceId: string): Promise<string> {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error("Authentication token not found");
      }
      
      const response = await axios.get(`/api/scribing/subscriptions/invoices/${invoiceId}/url`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });
      
      return response.data.url;
    } catch (error: any) {
      console.error("Error getting invoice URL:", error);
      throw error;
    }
  }
}; 